import { render, staticRenderFns } from "./edit-feedback-scale.vue?vue&type=template&id=f873a302&scoped=true&"
import script from "./edit-feedback-scale.vue?vue&type=script&lang=ts&"
export * from "./edit-feedback-scale.vue?vue&type=script&lang=ts&"
import style0 from "./edit-feedback-scale.vue?vue&type=style&index=0&id=f873a302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f873a302",
  null
  
)

export default component.exports